import styled from 'styled-components';

export const _TextAreaWrapper = styled('div').withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['errorIsARequiredField'].includes(prop) && defaultValidatorFn(prop),
})`
  textarea {
    font-family: ${(props) => props.theme.fontFamilyPrimary};
    border: 1px solid #1d1d1b;
    border-radius: 0;
    box-sizing: border-box;
    color: #1d1d1b;
    font-size: 1em;
    font-weight: 500;
    padding: 5px;
    margin-bottom: 15px;
    width: 100%;
    height: 100px;

    &:focus {
      border-color: ${(props) => props.theme.black};
      box-shadow: inset 0 0 3px #1b5f4b;
      background-color: #f2f2e6;
    }

    &.error {
      border-color: red;
      box-shadow: inset 0 0 3px red;
    }
  }
`;
